import styled, { css } from 'styled-components'
import ExternalLink from '../external-link'
import { ChevronRightIcon } from '../icons'
import { tabletBreakpoint, desktopBreakpoint } from 'react-components'
import { CarouselProvider, Slider } from 'pure-react-carousel'

export const Container = styled.div`
    width: 100%;
    overflow: hidden;
`

export const GridContainer = styled.div<{ columns: number }>(
    ({ theme, columns }) => css`
        display: grid;
        grid-template-columns: repeat(${columns}, 1fr);
        gap: ${theme.spacing.large};
        width: 100%;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            gap: ${theme.spacing.medium};
        }
    `,
)

export const SliderContainer = styled.div``

export const StyledCarouselProvider = styled(CarouselProvider)<{ margin?: string; center?: boolean }>(
    ({ center, margin = '0', theme }) => css`
        width: 100%;
        margin: ${margin};
        box-sizing: border-box;

        li {
            list-style: none;
        }

        ${center &&
        css`
            > .carousel__slider {
                padding: 0 ${theme.spacing.medium};

                @media only screen and (min-width: ${tabletBreakpoint.min}px) {
                    padding: 0 ${theme.spacing.large};
                }
            }
        `}
    `,
)

export const StyledSlider = styled(Slider)<{ $transitionTime?: number }>(
    ({ $transitionTime, theme }) => css`
        padding: 0;

        ul {
            transition: transform ${$transitionTime ? `${$transitionTime}s` : `0.5s`};
            transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
            will-change: transform;
        }

        .carousel__slider-tray {
            display: flex;
            gap: ${theme.spacing.medium};
        }
    `,
)

export const ColumnBox = styled.ul(
    ({ theme }) => css`
        border: 1px solid #d3d3d3;
        border-radius: 0.75rem;
        padding: ${theme.spacing.xSmall} ${theme.spacing.medium};
        display: flex;
        flex-direction: column;
        background: ${theme.colors.white};
        list-style: none;
    `,
)

export const RegionListItem = styled.li``

export const RegionItem = styled(ExternalLink)(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        gap: ${theme.spacing.small};
        text-decoration: none;
        color: inherit;
        cursor: pointer;
        transition: all 0.2s ease;
        padding: ${theme.spacing.xSmall} 0;
        border-radius: 8px;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            gap: ${theme.spacing.medium};
            padding: ${theme.spacing.xxSmall} 0;
        }
    `,
)

export const ImageWrapper = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    background: #f0f0f0;
    transition: transform 0.2s ease;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`

export const ContentContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    border-bottom: 1px dotted #d3d3d3;
    padding-bottom: 0.5rem;

    ${RegionListItem}:last-child & {
        border-bottom: none;
        padding-bottom: 0;
    }

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding-bottom: 0.625rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding-bottom: 0.75rem;
    }
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    flex: 1;
    min-width: 0;
`

export const Title = styled.div`
    font-family: ${props => props.theme.typography.font.family.lato};
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.375rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #282828;
`

export const SubTitle = styled.div(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-weight: ${theme.typography.font.weight.regular};
        font-size: ${theme.typography.font.size.small};
        line-height: ${theme.typography.font.size.medium};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #6f6f6f;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: 0.875rem;
            line-height: ${theme.typography.font.size.xLarge};
        }
    `,
)

export const IconContainer = styled.div`
    height: 1.25rem;
    width: 1.25rem;
    flex-shrink: 0;
    transition: transform 0.2s ease;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        height: 1.5rem;
        width: 1.5rem;
    }
`

export const ArrowRightIcon = styled(ChevronRightIcon)`
    width: 100%;
    height: 100%;

    & path {
        stroke: #a5a5a5;
        transition: stroke 0.2s ease;
    }
`
